import { Component, Vue } from 'vue-property-decorator';

@Component
export default class isProfileMixin extends Vue {
  get isProfile(): boolean {
    const {
      $route: { matched },
    } = this;
    return matched.some((record) => record.meta.isProfile);
  }
}



// WEBPACK FOOTER //
// ./src/mixins/isProfile.ts